import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaStatus', {
    bindings: {
      status: '<',
      idTipoNomina: '<',
    },
    template: template,
    controller: NominasNominaStatusComponent,
  })

function NominasNominaStatusComponent() {
  let $ctrl = this

  $ctrl.nominasColores = {
    'A': '#FFD600',
    'P': '#FF6D00',
    'C': '#64DD17',
  }

  $ctrl.nominasStatus = {
    A: 'Abierta',
    P: 'Pendiente',
    C: 'Cerrada',
  }

  $ctrl.nominasTipo = {
    0: 'ESP',
    1: 'SEM',
    2: 'DEC',
    3: 'QNA',
    4: 'MEN',
    5: 'CAT',
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/status/component.js